import React, { useEffect } from "react";
import "./sponsors.css";
import Box1 from "./box1";

import HomeNav from "../Home/homeNav";
import { useState } from "react";
import Box2 from "./box2";
import Donate from "./Donate";
import Footer from "../../components/Footer/footer";

var page2 = 0;

function Sponsors(props) {
  const [currTab, setCurrTab] = useState("Sponsors");
  const Tabs = ["Home", "Events", "Profile"];
  const [donate, setDonate] = useState(false);
  return (
    <div className="SponsorBack">
      <div style={{ animation: "fade_in_page 500ms ease-out" }} className={""}>
        {/* <div className="videoTag">
          <img className="videoTag" src={anim} alt="my-gif" />
        </div> */}
        {donate && <Donate setReg={setDonate}></Donate>}
        <HomeNav setCurrTab={setCurrTab} currTab={currTab} Tabs={Tabs} />
        {/* <div className="">
          <img className="aline1 " src={line} alt=""></img>
          <img className="aline2" src={line} alt=""></img>
          <img className="aline3" src={line} alt=""></img>
          <img className="aline4" src={line} alt=""></img>
        </div> */}

        <div className="sponsors-main">
          {/* <Box1 /> */}
          <Box2 setDonate={setDonate} donate={donate} />
        </div>
      </div>
    </div>
  );
}

export default Sponsors;
